export enum InquiryType {
  "Adoption" = "adoption",
  "Enterprise" = "enterprise",
  "BugReport" = "bug_report",
  "Feedback" = "feedback",
  "General" = "general",
  "DataErrorReport" = "data_error_report",
  "ItemsFailed" = "items_failed",
  "Unsubscribe" = "unsubscribe",
  "PublishedAgent" = "published_agent",
}
